import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface UserState {
  userName: string | null;
  isManageOrg: boolean;
  hasApprovalFlowEnabled: boolean;
  hasSelfServiceEnabled: boolean;
  hasTableauEnabled: boolean;
}

const initialState = {
  userName: null,
  isManageOrg: false,
  hasApprovalFlowEnabled: false,
  hasSelfServiceEnabled: false,
  hasTableauEnabled: false,
} as UserState;

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUsername: (state, action: PayloadAction<string>) => {
      state.userName = action.payload;
    },
    setIsManageOrg: (state, action: PayloadAction<boolean>) => {
      state.isManageOrg = action.payload;
    },
    setHasApprovalFlowEnabled: (state, action: PayloadAction<boolean>) => {
      state.hasApprovalFlowEnabled = action.payload;
    },
    setHasSelfServiceEnabled: (state, action: PayloadAction<boolean>) => {
      state.hasSelfServiceEnabled = action.payload;
    },
    setHasTableauEnabled: (state, action: PayloadAction<boolean>) => {
      state.hasTableauEnabled = action.payload;
    },
  },
});

export const {
  setUsername,
  setIsManageOrg,
  setHasApprovalFlowEnabled,
  setHasSelfServiceEnabled,
  setHasTableauEnabled,
} = userSlice.actions;

export const selectUsername = (state: RootState): string => state.user.userName;
export const selectIsManageOrg = (state: RootState): boolean => state.user.isManageOrg;
export const selectHasApprovalFlowEnabled = (state: RootState): boolean => state.user.hasApprovalFlowEnabled;
export const selectHasSelfServiceEnabled = (state: RootState): boolean => state.user.hasSelfServiceEnabled;
export const selectHasTableauEnabled = (state: RootState): boolean => state.user.hasTableauEnabled;

export default userSlice.reducer;
